module.exports = __webpack_public_path__ + "static/media/signage-indoor-img48.c871c434.jpg";